export default __webpack_public_path__ + "static/media/logo.d8c254c2.svg";